<template>
  <v-dialog :value="value" max-width="800" persistent :retain-focus="false">
    <FormNewWiedervorlage
      v-if="showNewForm"
      :user="user"
      :grund="grund"
      :calendarEvent="calendarEvent"
      @close="closeWvDialog"
      @open-event-dialog="openEventDialog"
    />
    <FormEditWiedervorlage
      v-if="showEditForm"
      :user="user"
      :wiedervorlage="wiedervorlage"
      @close="closeWvDialog"
    />
  </v-dialog>
</template>

<script>
import FormEditWiedervorlage from "@/components/forms/FormEditWiedervorlage.vue";
import FormNewWiedervorlage from "@/components/forms/FormNewWiedervorlage.vue";

export default {
  name: "WiedervorlageDialog",
  components: { FormNewWiedervorlage, FormEditWiedervorlage },
  props: {
    user: {
      type: Object,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
    showNewForm: {
      type: Boolean,
      required: true,
    },
    showEditForm: {
      type: Boolean,
      required: true,
    },
    wiedervorlage: {
      type: Object,
      required: false,
    },
    grund: {
      type: String,
      required: false,
    },
    calendarEvent: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      newWv: false,
      editWv: false,
      selectedWv: null,
    };
  },
  methods: {
    openEventDialog() {
      this.$emit("open-event-dialog");
    },
    closeWvDialog() {
      this.wvDialog = false;
      this.newWv = false;
      this.editWv = false;
      this.selectedWv = null;

      this.$emit("close");
    },
  },
};
</script>

<style scoped></style>
